export default __webpack_public_path__ + "372022c7e321b9edc382f9637869bad1.svg";